import React, { useEffect, useState } from 'react'
import { Card, Tabs, Tab } from 'react-bootstrap'
import ApprovedApps from './ApprovedApps';
import DisapprovedApps from './DisapprovedApps';
import BlockUi from '@availity/block-ui';
import '@availity/block-ui/dist/index.css';

function ApplicationInfoPage() {
    const [gridType, setGridType] = useState("received");
    const [blockUI, toggleBlockUi] = useState(false);
    useEffect(() => {

    }, [])

    return (
        <>
            <h3 className="mb-3">Application Info</h3>
            <BlockUi blocking={blockUI}>
                <Card>
                    <Card.Body>
                        <Tabs activeKey={gridType} transition={false} onSelect={(selected) => { setGridType(selected) }}>
                            <Tab eventKey="approved" title="Approved">
                                <hr />
                                <ApprovedApps propsIsActive={gridType === 'approved'} statusType={gridType} />
                            </Tab>
                            <Tab eventKey="disapproved" title="Disapproved">
                                <hr />
                                {/*<DisapprovedApps propsIsActive={gridType === 'disapproved'} />*/}
                            </Tab>
                        </Tabs>
                    </Card.Body>
                </Card>
            </BlockUi>
        </>
    );
}
export default ApplicationInfoPage;